import { Row } from 'antd';
import Button from 'components/Button';
import { newAppointmentVersionV2Ref } from 'features/appointment/pages/AppointmentsPage/components/Calendar/TableView/Body/Modal/NewAppointmentV2/v2';
import { blockHoursRef } from 'features/appointment/pages/AppointmentsPage/components/Calendar/TableView/Body/Modal/BlockHours';
import appointmentActions from 'features/appointment/services/actions';
import { APPOINTMENT_LAYOUT } from 'features/appointment/services/constants';
import appointmentSelectors from 'features/appointment/services/selectors';
import moment from 'moment';
import { useAppDispatch } from 'store/hooks';
import { momentTimezone } from 'utils/time';
import { quickBookingRef } from './Calendar/TableView/Body/Modal/QuickBooking';
import StaffsDayOff from './StaffsDayOff';
import { quickBookingV2Ref } from './Calendar/TableView/Body/Modal/QuickBookingV2';
import shopSelectors from 'services/shop/selectors';
export const calcColTime = () => {
  const params = appointmentSelectors.paramsMasterData();
  const tableParams = appointmentSelectors.table.params();
  const layout = appointmentSelectors.getAppointmentLayout();

  const colTime = () => {
    const now = moment().add(15, 'minute');
    const nowTime = [0, 15, 30, 45, 60].map(o => ({ key: o, value: (now.get('minute') - o) })).filter(o => o.value >= 0);

    const minute = nowTime.find(o => o.value === Math.min(...nowTime.map(o => o.value)))?.key;
    if (layout === APPOINTMENT_LAYOUT.CALENDAR) {
      if (!params?.date) return undefined;

      const startTime = momentTimezone(params?.date).set({
        hour: now.get('hour'),
        minute: minute ?? now.get('minute'),
        second: 0,
      });
      if (startTime.isSameOrAfter(now, 'date'))
        return startTime.format();
      return undefined;
    } else if (layout === APPOINTMENT_LAYOUT.LIST) {
      if (!tableParams?.startTime) return undefined;
      const startTime = momentTimezone(tableParams?.startTime).set({
        hour: now.get('hour'),
        minute: minute ?? now.get('minute'),
        second: 0,
      });
      if (startTime.isSameOrAfter(now, 'date'))
        return startTime.format();
      return undefined;
    }

    return undefined;
  };
  return colTime;
};
const Actions = () => {
  const colTime = calcColTime();
  const dispatch = useAppDispatch();
  const allSetting = shopSelectors.data.allSetting();
  const newAppointment = () => newAppointmentVersionV2Ref.current?.open({
    colTime: colTime(),
    newApt: true,
  });

  const newBlockHour = () => {
    blockHoursRef.current?.open({
      colTime: colTime(),
    });
  };

  const newBreakTime = () => {
    dispatch(appointmentActions.setNewBreakTimeDraftData({
      colTime: colTime(),
    }));
  };

  const newQuickBooking = () => {
    if (allSetting?.displayQuickBookV2) {
      quickBookingV2Ref.current?.open();
    } else {
      quickBookingRef.current?.open(colTime() || '');
    }
  };

  return (
    <Row className='header-actions' style={{ gap: '1rem' }}>
      <StaffsDayOff />
      <Button ntype="SECONDARY" size='middle' icon='time' onClick={newBlockHour} >Block Hours</Button>
      <Button ntype="SECONDARY" size='middle' icon='time' onClick={newBreakTime} >On Break</Button>
      <Button ntype="LIGHT_BLUE" size='middle' icon='addPlus' onClick={newQuickBooking} >Quick Booking</Button>
      <Button ntype="PRIMARY" size='middle' icon='addPlus' onClick={newAppointment}>Add New Appointment</Button>
    </Row>
  );
};

export default Actions;